import { default as api } from 'config/frontApiConf';

export const loginUser = async (data) => {
	try {
		let result = await api.post('/login', data);
		return result;
	} catch (error) {
		return error;
	}
};
